export enum Symptom {
  CONSTIPATION = 'constipation',
  DIARRHEA = 'diarrhea',
  NAUSEA = 'nausea',
  PAIN = 'pain',
  SHORTNESS_OF_BREATH = 'shortness_of_breath',
  URINARY = 'urinary',
  VOMITING = 'vomiting',
}

export enum Measure {
  SEVERITY = 'severity',
  FREQUENCY = 'frequency',
  LIFE_IMPACT = 'life_impact',
}
